// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/IMG_3189.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
  height: 100vh;
  background-image: linear-gradient(
      rgba(15, 15, 15, 0.2),
      rgba(15, 15, 15, 0.6)
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center center; /* Center the background image */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  padding: 5rem;
  font-family: "Inter";
}

.error-header {
  color: white;
  text-align: center;
  margin-bottom: 2rem;
}

.error-mnd {
  font-size: 6.8rem;
  font-family: "Inter";
  font-weight: bold;
  color: rgba(255, 255, 255, 0.5);
}

.error-btns {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}

.error-btn {
  border: none;
  font-family: "Inter";
  font-weight: bold;
  text-transform: uppercase;
  font-size: 3.2rem;
  border-radius: 100rem;
  cursor: pointer;
  transition: 0.3s;
  padding: 1rem 2rem;
  justify-content: center;
  align-items: center;
}

.error-btn:hover {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: scale(1.05);
}`, "",{"version":3,"sources":["webpack://./src/components/ErrorPage/ErrorPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb;;;;2CAIsC;EACtC,sBAAsB;EACtB,kCAAkC,EAAE,gCAAgC;EACpE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,sBAAsB;AACxB","sourcesContent":[".error-container {\n  height: 100vh;\n  background-image: linear-gradient(\n      rgba(15, 15, 15, 0.2),\n      rgba(15, 15, 15, 0.6)\n    ),\n    url(\"../../../public/IMG_3189.jpeg\");\n  background-size: cover;\n  background-position: center center; /* Center the background image */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  width: 100vw;\n  padding: 5rem;\n  font-family: \"Inter\";\n}\n\n.error-header {\n  color: white;\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.error-mnd {\n  font-size: 6.8rem;\n  font-family: \"Inter\";\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.error-btns {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n}\n\n.error-btn {\n  border: none;\n  font-family: \"Inter\";\n  font-weight: bold;\n  text-transform: uppercase;\n  font-size: 3.2rem;\n  border-radius: 100rem;\n  cursor: pointer;\n  transition: 0.3s;\n  padding: 1rem 2rem;\n  justify-content: center;\n  align-items: center;\n}\n\n.error-btn:hover {\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n  transform: scale(1.05);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
